import { render, staticRenderFns } from "./transferCase.vue?vue&type=template&id=5ef4b5ef"
import script from "./transferCase.vue?vue&type=script&lang=js"
export * from "./transferCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports